import React, { Fragment, useMemo } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { usePermissions, useTranslate } from "ra-core";
import { APP_URL } from "../../config";
import DownloadButton from "../../component/button/DownloadButton";
import { ImageField } from "ra-ui-materialui";
import IsPublicInput from "../../project-media/inputs/IsPublicInput";
import { get } from "lodash";
import { ReferenceListField, useMakeRedirect } from "ra-friendsofbabba";
import DeleteButton from "../buttons/DeleteButton";
import useFormPermission from "../useFormPermission";

const useStyles = makeStyles((theme) => ({
  pic: {
    "& img": {
      margin: 0,
      padding: 0,
    },
  },
}));

const ThumbnailField = ({ source, record }) => {
  const path = get(record, source);
  const classes = useStyles();
  const thumbnail = `${APP_URL}resize/${path}?h=400`;
  const translate = useTranslate();
  const type = get(record, "media_type");
  const label = useMemo(
    () => translate(`resources.project-media.fields.media_type.${type}`),
    [type, translate]
  );

  return (
    <Fragment>
      <a
        href={get(record, "media.file.path")}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ImageField
          className={classes.pic}
          source={"thumbnail"}
          record={{ thumbnail }}
        />
      </a>
      <Typography component="em" variant="caption">
        {label}
      </Typography>
    </Fragment>
  );
};

const ProjectMediaField = ({ tab = 4, ...props }) => {
  const hasFormPermission = useFormPermission();
  const disabled = !hasFormPermission(props.source);
  const { permissions, loaded } = usePermissions();
  const isRegion = loaded && permissions && permissions(["region", "admin"]);
  const makeRedirect = useMakeRedirect({
    resource: "projects",
    record: props.record,
    tab: 4,
  });
  return (
    <ReferenceListField
      {...props}
      reference="project-media"
      target="project_id"
      tab={tab}
      perPage={5}
      addLabel={false}
      createLabel="ra.action.add_project_media"
      create={!props.disabled && !disabled}
      modify={false}
      remove={false}
      mobilePrimaryText="app.filename"
      mobileSecondaryText="media.filepath"
      mobileTertiaryText="is_public"
      mobileBreakpoint="xs"
    >
      <ThumbnailField source="media.filepath" label="app.filename" />
      {isRegion && <IsPublicInput source="is_public" />}
      <DownloadButton />
      <DeleteButton
        disabled={props.disabled || disabled}
        confirmContent={(record, translate) =>
          translate("ra.messages.confirm_file_delete", {
            filename: record.media.filename,
          })
        }
        redirect={makeRedirect}
      />
    </ReferenceListField>
  );
};

export default ProjectMediaField;
